import {
  AfterViewChecked,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { TenantService } from './shared/services/tenant/tenant.service';
import { Location } from '@angular/common';
import { environment } from 'src/environment/environment';
import {
  updateCSS,
  getHostName,
  AnalyticsService,
  ScriptLoaderService,
  loaderIcon,
} from '@laasy/common-layout';
import { replaceColor } from 'lottie-colorify';
import { LoginLoaderService } from './shared/services/common/loader.service';
import { Utils } from './shared/utilities/utils';
import { astraStyle } from './shared/style/astraStyle';
import { AuthenticationService } from './shared/services/authentication/authentication.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { storeSignupCode } from './modules/auth/auth-utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'LaaSy';
  favIcon: any;

  layoutComponent: string = 'app-layout';
  @ViewChild('toast', { read: ElementRef, static: false }) toastElementRef: ElementRef | undefined;
  private observerInitialized = false;
  showLoginLoader = false;
  hostName: string = ''
  loaderIcon: string = '';

  constructor(
    private loaderService: LoginLoaderService,
    private location: Location,
    private tenantService: TenantService,
    private readonly authenticationService: AuthenticationService,
    private scriptService:ScriptLoaderService,
    private analyticsService: AnalyticsService,
    private router: Router
  ) { }

    ngOnInit() {
    this.loaderIcon = loaderIcon;
    this.tenant_config();
    this.loaderService.isLoginLoader.asObservable().subscribe(show => {
      this.showLoginLoader = show;
    });
    this.addAstraStyle();
    this.captureSignupCodeFromDeepLink();
    setInterval(() => this.refreshToken(), environment.refreshTokenInterval * 60 * 1000)
  }

  private captureSignupCodeFromDeepLink() {
    const check = () => {
      const code = new URL(window.location.href).searchParams.get('signupCode')
        ?? this.getSignupCodeFromCachedRedirect();
      if (code) storeSignupCode(code);
    };
    check();
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => check());
  }

  private getSignupCodeFromCachedRedirect(): string | null {
    const cached = sessionStorage.getItem('post-login-redirect');
    if (!cached) return null;
    try {
      // Inverse of btoa(unescape(encodeURIComponent(...))) used in AuthGuard
      const decoded = decodeURIComponent(escape(atob(cached)));
      return new URL(decoded).searchParams.get('signupCode');
    } catch {
      return null;
    }
  }

  async refreshToken() {
    const currentSession = await this.authenticationService.GetCurrentSession()
    if (currentSession !== null) {
      const idTokenExpire = currentSession.getIdToken().getExpiration()
      sessionStorage.setItem("token_expire_datetime", idTokenExpire)
    }
  }

  tenant_config() {
    this.favIcon = document.querySelector('#appIcon');
    if (!sessionStorage.getItem('mytenant'))
      updateCSS({
        logo: '../assets/images/LaaSyClientLogo.png',
        loginBackground: '../assets/images/auth-background.svg',
        color1: '#FDDA01'
      });
    this.getTenantsDomain();
  }

  getTenantsDomain() {
    this.hostName = getHostName(this.location)
  }



  ngAfterViewChecked(): void {
    const analytics = this.analyticsService.getSegmentAnalytics();
    if (analytics)
      this.observerInitialized = this.analyticsService.analytics_capture_toast(
        analytics,
        this.observerInitialized,
        this.toastElementRef
      );
  }

  addAstraStyle() {
    // Adding style this way coz css-purge is removing id selectors from final css file
    const styleElement = document.createElement('style');
    styleElement.textContent = astraStyle
    document.head.appendChild(styleElement);
  }

}
